import { Play } from '@vgno/icons';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { LinkButton } from '../../LinkButton/LinkButton';

import type { FC, MouseEventHandler } from 'react';

import * as styles from './PlayButton.module.scss';

interface PlayButtonProps {
  skipLabel?: boolean;
  assetUrl: string;
  onClick?: MouseEventHandler;
}

const PlayButton: FC<PlayButtonProps> = ({
  skipLabel = false,
  assetUrl,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <LinkButton
        round
        url={assetUrl}
        variant="contained"
        size="large"
        isActiveBrandColor
        className={classNames(styles.icon, { [styles.circle]: skipLabel })}
        onClick={(event) => {
          event.stopPropagation();
          if (onClick) {
            onClick(event);
          }
        }}
      >
        <Play />
        {!skipLabel && t('Play')}
      </LinkButton>
    </div>
  );
};

export { PlayButton };
